/**
 * GROW PARIS — Duo Mini Composer (PDP BOGO)
 * Gère la sélection de la 2e paire offerte et l'ajout au panier.
 *
 * TODO (discount wiring): La 2e ligne porte la propriété _bogo_free:true.
 * Pour appliquer -100%, utilise une Shopify Function (cart discount),
 * l'app BOGOS, ou une discount automatique via Shopify Discount API.
 */
(function () {
  var freePair   = null;
  var freeHandle = null;

  window.pickFreePair = function (el) {
    document.querySelectorAll('.duo-mini__choice').forEach(function (c) {
      c.classList.remove('is-active');
    });
    el.classList.add('is-active');

    freePair   = el.dataset.name;
    freeHandle = el.dataset.handle || null;

    var ph     = document.getElementById('duoPreviewPh');
    var nameEl = document.getElementById('duoPreviewName');
    var price  = document.getElementById('duoPreviewPrice');
    var imgSrc = el.dataset.img;

    if (ph && imgSrc) {
      ph.outerHTML =
        '<img src="' + imgSrc + '" alt="' + (freePair || '') + '"' +
        ' id="duoPreviewPh"' +
        ' style="width:44px;height:44px;object-fit:cover;flex-shrink:0;border:2px solid var(--bogo-accent);">';
    }
    if (nameEl) {
      nameEl.textContent = freePair;
      nameEl.style.color = '';
    }
    if (price) price.textContent = '0€ · OFFERTE';

    var cta = document.getElementById('duoCta');
    if (cta) {
      cta.disabled = false;
      cta.dataset.freeHandle = freeHandle || '';
      var activeLabel = cta.dataset.activeLabel || (window.growStrings && window.growStrings.duoCtaFull) || 'Ajouter le duo au panier';
      cta.innerHTML =
        activeLabel +
        ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
        '<path d="M5 12h14M13 5l7 7-7 7"/></svg>';
    }
  };

  window.addDuoToCart = function () {
    if (!freePair && !freeHandle) return;
    var cta      = document.getElementById('duoCta');
    var mainName = (document.querySelector('[data-pdp-main-name]') || {}).dataset || {};
    var mainHandle = cta ? cta.dataset.mainHandle : null;
    var original = cta ? cta.innerHTML : '';

    if (cta) {
      cta.innerHTML =
        ((window.growStrings && window.growStrings.duoAdded) || '✓ Duo ajouté') +
        (mainName.pdpMainName ? ' · ' + mainName.pdpMainName : '') +
        (freePair ? ' + ' + freePair : '');
      cta.style.background = 'var(--bogo-accent)';
      cta.style.color      = 'var(--bogo-fg)';
    }

    if (typeof window.GrowAddDuoToCart === 'function') {
      window.GrowAddDuoToCart(mainHandle, freeHandle);
    }

    setTimeout(function () {
      if (cta) {
        cta.innerHTML        = original;
        cta.style.background = '';
        cta.style.color      = '';
      }
    }, 2400);
  };

  /**
   * Ajoute les 2 produits via /cart/add.js.
   * La 2e ligne porte _bogo_free:true pour que la Shopify Function applique -100%.
   */
  window.GrowAddDuoToCart = async function (mainHandle, freeHandle) {
    if (!mainHandle || !freeHandle) return;
    try {
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var mainProduct = await fetch(root + 'products/' + mainHandle + '.js').then(function (r) { return r.json(); });
      var freeProduct = await fetch(root + 'products/' + freeHandle + '.js').then(function (r) { return r.json(); });

      var mainVid = window.GROW_SELECTED_VID || mainProduct.variants[0].id;
      var formData = {
        items: [
          { id: mainVid, quantity: 1 },
          { id: freeProduct.variants[0].id, quantity: 1, properties: { _bogo_free: 'true' } }
        ]
      };

      await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      document.documentElement.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      console.error('[GROW BOGO] Failed to add duo to cart:', err);
    }
  };
})();
